export default "__VITE_ASSET__c628c50c__"